export default {
  title: 'Bezorgproviders',
};
